<div class="dialog">
  <header class="dialog__header">
    <h3 class="dialog__header__title">{{ data?.title | translate }}</h3>
    <div class="dialog__header__action-buttons">
      <div (click)="closeDialog()" class="dialog__header__action-buttons__button">
        <span>
          <app-icon [cssStyle]="{ 'margin-top': '3px' }" iconName="close" size="14px"></app-icon>
        </span>
      </div>
    </div>
  </header>

  <div class="dialog__content">
    @if (!data.messageHTML) {
      <p>
        {{ message }}
        @if (data?.emphasize) {
          <strong>{{ data?.emphasize }}</strong>
        }
        @if (data.postEmphasizeMessage) {
          {{ data.postEmphasizeMessage }}
        }
        @if (!isSimpleMessage) {
          ?
        }
      </p>
    }
    @if (data.messageHTML) {
      <p [innerHTML]="data.messageHTML"></p>
    }
  </div>

  <footer class="dialog__footer">
    <div class="dialog__footer__buttons">
      <app-button
        (click)="closeDialog()"
        [idleText]="data?.cancelButtonText"
        [inlineStyle]="{ border: '1px solid var(--gray)' }"
        backgroundColor="var(--white)"
        borderColor="var(--gray)"
        color="var(--dark-charcoal)"
        width="127px"
      ></app-button>
      @if (!isSimpleMessage) {
        <app-button (click)="closeDialog(true)" [idleText]="data?.confirmButtonText" width="127px"></app-button>
      }
    </div>
  </footer>
</div>
